import React from 'react'
import { useSelector } from 'react-redux'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import useObservable from 'libraries/front-end-core/hooks/useObservable'
import { requestReferenceNodes } from 'services/LegislationReferenceService'
import LegislationReferenceComponentContainer from 'redux/containers/components/legislation-reference/LegislationReferenceComponentContainer'
import selectMouseabilityReference from 'redux/selectors/selectMouseabilityReference'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import ExpiredLegislation from './ExpiredLegislation'
import { startWith } from 'rxjs'

export default function LegislationReference (props) {
  const references = useSelector(selectMouseabilityReference)
  const referencesResponse = useObservable(
    requestReferenceNodes({ references }).pipe(
      startWith(RESPONSE_PENDING)
    ),
    RESPONSE_PENDING,
    [references]
  )

  return (
    <ResponseConsumer
      response={referencesResponse}
      content={() => <LegislationReferenceComponentContainer {...props} references={referencesResponse} />}
      pendingComponent={() =>
        <LegislationReferenceComponentContainer
          {...props}
          references={referencesResponse}
        />}
      notfoundComponent={() => (
        <ExpiredLegislation {...props} />
      )}
    />
  )
}
